
define('app/board/views/deletePickView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/pickCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/pickModel',
], function($, _, Backbone, PickSummaryCollection, PickCollection, LeagueInstanceModel, PickModel){

	var DeletePickFooterView = Backbone.View.extend({
		events: {
			'click #delPickSubmit': 'submitDelPick',
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showDelPick();
			
			this.listenTo(this.event, 'default', this.showDelPick);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showDelPick);
			//this.listenTo(this.event, 'success', this.hideAll);
		},
		
		hideAll: function () {
			$(this.el).hide();
		},
		
		submitDelPick: function () {
			this.event.trigger("save");
		},
		
		showDelPick: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var DeletePickContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.lgInst = options.lgInst;
			this.pickCollection = options.pickCollection;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.event = options.event;
			this.pickSumIdDel = 0;
			this.newPickSumIdDel = 0;
			
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.hideAll();
			
			this.listenTo(this.event, 'save', this.submitDelPick);
			this.listenTo(this.event, 'default', this.delPickInfo);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.delPickInfo);
			//this.listenTo(this.event, 'success', this.hideAll);
		},
		
		submitDelPick: function () {
			if(!this.submittedData.isSubmitted && this.pickSumIdDel > 0){
				this.event.trigger("saving");
				this.submittedData.isSubmitted = true;
				
				var pickSummaryObj = this.pickSummaryCollection.get(this.pickSumIdDel);
				var round = pickSummaryObj.get('round');
				var posInRound = pickSummaryObj.get('posInRound');
				
				if(this.lgInst.get('draftType') == 'AUCTION'){
					round = pickSummaryObj.get('auctionRound');
					posInRound = pickSummaryObj.get('auctionPosInRound');
				}				
				
				var pick = this.pickCollection.getPickByPosRound(round, posInRound);
				//pick = this.pickCollection.get(this.pickSummaryCollection.get(this.posRoundIdDel).get('pickId'));
				
				if(pick){
					this.newPickSumIdDel = this.pickSumIdDel;
					//pick.destroy({success: this.successCallback, error: this.errorCallback, wait: true});
					
					$.ajax({
						headers : {
							"Content-Type" : "application/json",
							"Accept" : "application/json"
						},
						url : 
							'/draftapp/leagues/' 
							+ this.lgInst.get('leagueId') 
							+ '/league-instances/' 
							+ this.lgInst.get('id') 
							+ '/picks/'
							+ pick.get('id'),
						type : 'DELETE',
						dataType : 'json',
						//data : JSON.stringify(dataJson, null, 2),
						success: this.successCallback,
						error: this.errorCallback
					});
					
				} else {
					this.event.trigger("error");
				}
			}
		},
		
		successCallback: function(model, response) {
			this.submittedData.isSubmitted = false;
			
			//This helps prevent a race condition with posRoundIdDel being updated
			if(this.newPickSumIdDel == this.pickSumIdDel){
				this.pickSumIdDel = 0;
				this.newPickSumIdDel = 0;
			}
			
			$('.delPickTrigger').first().dropdown('toggle');
			this.event.trigger("success", model, response);
		},
		
		errorCallback: function(model, error) {
			this.submittedData.isSubmitted = false;
			this.event.trigger("error", model, error);
		},
		
		hideAll: function() {
			$("#delPickTitle").hide();
			this.$("#delPickBodyContentInfo").hide();
		},
		
		delPickInfo: function () {
			this.hideAll();
			this.populatePickInfo();
			$("#delPickTitle").show();
			this.$("#delPickBodyContentInfo").show();
		},
		
		populatePickInfo: function () {
			if(this.pickSumIdDel > 0){
				var pickSummaryObj = this.pickSummaryCollection.get(this.pickSumIdDel);				
				var teamName = this.lgInst.getTeam(pickSummaryObj.get('fantasyTeamId')).get('teamName');
				
				this.$("#delPickFName").html(pickSummaryObj.get("fName"));
				this.$("#delPickLName").html(pickSummaryObj.get("lName"));
				this.$("#delPickPos").html(pickSummaryObj.get("playerPos"));
				this.$("#delPickTeam").html(pickSummaryObj.get("teamAbbr"));
				this.$("#delPickFantTeam").html(teamName);
				this.$("#delPickOvrNum").html(pickSummaryObj.get("ovrPickNum"));
				this.$("#delPickRoundNum").html(pickSummaryObj.get("round"));
				this.$("#delPickPickNum").html(pickSummaryObj.get("posInRound"));
			} else {
				this.$("#delPickFName").html('&nbsp;');
				this.$("#delPickLName").html('&nbsp;');
				this.$("#delPickPos").html('&nbsp;');
				this.$("#delPickTeam").html('&nbsp;');
				this.$("#delPickFantTeam").html('&nbsp;');
				this.$("#delPickOvrNum").html('&nbsp;');
				this.$("#delPickRoundNum").html('&nbsp;');
				this.$("#delPickPickNum").html('&nbsp;');
			}
		},
		
		updatePickSumId: function(updatePickSumId) {
			this.pickSumIdDel = updatePickSumId;
		},
		
		destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});

	var DeletePickMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			
			this.hideAll();
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			//this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#delPickBodyMessageError").hide();
			this.$("#delPickBodyMessageProcessing").hide();
			this.$("#delPickBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#delPickBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#delPickBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#delPickBodyMessageProcessing").show();
		},
		
		destroyView: function() {
	    	this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	var DeletePickView = Backbone.View.extend({
		el: $("#delPickContent"),
		
		initialize: function(options) {
			this.lgInst = options.lgInst;
			this.pickCollection = options.pickCollection;
			this.pickSummaryCollection = options.pickSummaryCollection;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'updatePickSumId');
			
			this.message = new DeletePickMessageView({el: this.$("#delPickBodyMessage"), event: this.event});
			this.content = new DeletePickContentView({
					el: this.$("#delPickBodyContent"), 
					event: this.event,
					submittedData : this.submittedData,
					pickSummaryCollection: this.pickSummaryCollection, 
					lgInst: this.lgInst,
					pickCollection: this.pickCollection});
			this.footer = new DeletePickFooterView({el: this.$("#delPickSubmitFooter"), event: this.event});
			
			$(".delPickTrigger").on("click", function(event){
				var width = $(document).width();
				var height = $(document).height();
				
				$('#delPickPopup .dropdown-menu').css('top', event.pageY + 15);
				$('#delPickPopup .dropdown-menu').css('right', width - event.pageX);
			});
			
			$(document).on('draftApp:delPickSum', this.updatePickSumId);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		updatePickSumId: function(event, updatePickSumId) {
			this.content.updatePickSumId(updatePickSumId);
			this.render();
		},
		
		destroyView: function() {
			$(document).off('draftApp:delPickSum', this.updatePickSumId);
			$(".delPickTrigger").off("click");
			
			this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
			
			this.stopListening();
	    	this.undelegateEvents();
        }
	});
	
	return DeletePickView;  
});